import { useState, useCallback, useRef, useEffect } from 'react';

/** @deprecated Use `useCopyToClipboard` from `@bridebook/aura` instead. */
const useCopyToClipboard = (timeout: number = 2000) => {
  const [copiedText, setCopiedText] = useState<string | undefined>(undefined);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const copy = useCallback(
    async (text: string) => {
      if (!navigator?.clipboard) {
        return false;
      }

      // Clear existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Try to save to clipboard then save it in the state if worked
      try {
        await navigator.clipboard.writeText(text);
        setCopiedText(text);

        // Reset copied text after timeout
        timeoutRef.current = setTimeout(() => {
          setCopiedText(undefined);
        }, timeout);

        return true;
      } catch (error) {
        setCopiedText(undefined);
        return false;
      }
    },
    [timeout],
  );

  // Cleanup timeout on unmount
  useEffect(
    () => () => {
      setCopiedText(undefined);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    },
    [],
  );

  return { copiedText, copy };
};

export default useCopyToClipboard;
